const PROTOCOL_SCHEMA = process.env.NODE_ENV !== 'development' ? 'https' : 'http'
const PORT = process.env.NODE_ENV !== 'development' ? undefined : '3000'

let sites = {
  it: 'www.emilgroup.it',
  en: 'www.emilgroup.com',
  de: 'www.emilgroup.de',
  fra: 'www.emilgroup.fr',
  esp: 'www.emilgroup.es',
  us: 'www.emilamerica.com',
  es: 'www.emilamerica.com',
  fr: 'www.emilamerica.com',
}

if (process.env.NODE_ENV === 'staging' || process.env.TEMP_ENV === 'staging') {
  sites = {
    it: 'it.emilceramica-next.webranking.biz',
    en: 'en.emilceramica-next.webranking.biz',
    de: 'de.emilceramica-next.webranking.biz',
    fra: 'fr.emilceramica-next.webranking.biz',
    esp: 'es.emilceramica-next.webranking.biz',
    us: 'us.emilceramica-next.webranking.biz',
    es: 'us.emilceramica-next.webranking.biz',
    fr: 'us.emilceramica-next.webranking.biz',
  }
}

if (process.env.NODE_ENV === 'development') {
  sites = {
    it: 'it.localhost',
    en: 'en.localhost',
    de: 'de.localhost',
    fra: 'fr.localhost',
    esp: 'es.localhost',
    us: 'us.localhost',
    es: 'us.localhost',
    fr: 'us.localhost',
  }
}

const siteKeys = Object.keys(sites)

const locales = ['it', 'en', 'de', 'fra', 'esp', 'us', 'es', 'fr']
const localesBackendMap = {
  it: 'it',
  en: 'en',
  de: 'de',
  fra: 'fr',
  esp: 'es',
  us: 'us',
  es: 'us_es',
  fr: 'us_fr',
}
const pseudoLocales = locales
const defaultLocale = 'it'
const http = PROTOCOL_SCHEMA === 'http'

const DOMAIN = sites[defaultLocale]

const DOMAINS = sites

const INTERNAL_DOMAINS = ['#', '127.0.0.1', 'localhost', ...Object.values(DOMAINS).flat()]

const browserLanguageToLocaleMap = {
  'it-IT': 'it',
  'it': 'it',
  'en': 'en',
  'en-GB': 'en',
  'de-DE': 'de',
  'de': 'de',
  'fr-FR': 'fra',
  'fr': 'fra',
  'es-ES': 'esp',
  'es': 'esp',
  'es-AR': 'es',
  'es-BO': 'es',
  'es-CL': 'es',
  'es-CO': 'es',
  'es-CR': 'es',
  'es-DO': 'es',
  'es-EC': 'es',
  'es-GT': 'es',
  'es-HN': 'es',
  'es-MX': 'es',
  'es-NI': 'es',
  'es-PA': 'es',
  'es-PE': 'es',
  'es-PR': 'es',
  'es-PY': 'es',
  'es-SV': 'es',
  'es-UY': 'es',
  'es-VE': 'es',
  'fr-CA': 'fr',
  'en-US': 'us',
  'us': 'us',
}

const localesCountryTextMap = {
  it: {
    name: 'Ti trovi in Italia?',
    alias: 'Visita il sito Emilgroup Italia',
  },
  en: {
    name: 'Are you in England?',
    alias: 'Visit the Emilgroup International website',
  },
  de: {
    name: 'Bist du in Deutschland?',
    alias: 'Besuche die Website von Emilgroup Deutschland',
  },
  fra: {
    name: 'Tu te trouves en France?',
    alias: 'Visitez le site Emilgroup France',
  },
  esp: {
    name: '¿Te encuentras en España?',
    alias: 'Visita el sitio de Emilgroup España',
  },
  us: {
    name: 'Are you in the United States?',
    alias: 'Visit the EmilAmerica USA website',
  },
  es: {
    name: '¿Estás en América?',
    alias: 'Visita el sitio EmilAmerica ESP',
  },
  fr: {
    name: 'Est-ce que tu te trouves en Amérique?',
    alias: 'Visite le site EmilAmerica FRA',
  },
}

module.exports = {
  sites,
  siteKeys,
  locales,
  localesBackendMap,
  localesCountryTextMap,
  pseudoLocales,
  defaultLocale,
  http,
  PROTOCOL_SCHEMA,
  PORT,
  DOMAIN,
  DOMAINS,
  INTERNAL_DOMAINS,
  browserLanguageToLocaleMap,
}
